import { useLocation, useRouteLoaderData } from 'react-router'

import { PortalLandingPageLoader } from '../routes/_docs+/loader'
import { ProductPageLoaderData } from '~/portal/routes/_docs.$productname/loader'
import { LandingProduct } from '~/portal/types/product'
import { PORTAL_PRODUCT_ROLE } from '~/shared/types/product'

export const useProducts = (): {
  currentProduct?: LandingProduct,
  products: LandingProduct[],
  productSlug?: string,
  currentProductRole?: PORTAL_PRODUCT_ROLE,
} => {
  const location = useLocation()
  const landingData = useRouteLoaderData<PortalLandingPageLoader>('routes/_docs+/_index')
  const productData = useRouteLoaderData<ProductPageLoaderData>('routes/_docs.$productname/_index')

  if (location.pathname === '/') {
    return {
      currentProduct: undefined,
      products: (landingData?.products)?.filter(p => p.canAccess) || [],
      productSlug: undefined,
      currentProductRole: undefined
    }
  }
  
  const currentProduct = productData?.currentProduct
  const products = productData?.products || []
  const productSlug = productData?.productSlug
  const currentProductRole = productData?.currentProductRole

  return { currentProduct, currentProductRole, products, productSlug }
}